import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") || path.startsWith("/worker")) {
        localStorage.removeItem("gas_token");
        localStorage.removeItem("gas_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function saveAuth(token, user) {
  localStorage.setItem("gas_token", token);
  localStorage.setItem("gas_user", JSON.stringify(user));
}

export function getAuthUser() {
  try {
    const raw = localStorage.getItem("gas_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function logout() {
  localStorage.removeItem("gas_token");
  localStorage.removeItem("gas_user");
}
